import { Component, inject } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'dk-forbidden',
  imports: [SharedModule],
  templateUrl: './dk-forbidden.component.html',
  styleUrl: './dk-forbidden.component.less',
})
export class DkForbiddenComponent {
  private readonly _dialogRef = inject(DynamicDialogRef);

  close() {
    this._dialogRef.close();
  }
}
